import React, { useState } from 'react'
import { providerService } from 'services'
import { _Object, closeModal } from 'utils/common-functions'

const DeleteProvider = ({ getProviders, selectedProvider }: _Object) => {
	const [loading, setLoading] = useState<boolean>(false)

	const deleteItem = () => {
		setLoading(true)

		providerService.deleteProvider(selectedProvider.id).then((data: _Object) => {
			!data.error && getProviders()
			setLoading(false);
			closeModal('DeleteProvider')
		})
	}

	return (
		<div className="modal fade" id="DeleteProvider" aria-labelledby="DeleteProviderLabel" aria-hidden="true" data-bs-backdrop="static" tabIndex={-1}>
			<div className="modal-dialog modal-dialog-centered ">
				<div className="modal-content">
					<div className="modal-header">
						<h5 className="mb-0">Confirm Delete</h5>
						<button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
					</div>
					<div className="modal-body">
						Are you sure?
					</div>
					<div className="modal-footer">
						<button type="button" className="btn btn-secondary mx-3" data-bs-dismiss="modal" aria-label="Close">No, cancel</button>
						<button type="submit" className={`btn btn-danger ${loading ? 'btn-loading' : ''} `}
							disabled={loading} onClick={deleteItem}>Yes, delete</button>
					</div>
				</div>
			</div>
		</div>
	)
}
export default DeleteProvider